module.exports = __webpack_public_path__ + "static/genuine-leather-photo-book-c1f091302c374135ba494cbebf676263.jpg";